/**
 * Created by DejanK on 2/1/2017.
 */
import angular from 'angular';

import './rb-virtual-repeat.scss';

import rbVirtualRepeatContainer from './rb-virtual-repeat-container.dir'
import rbVirtualRepeat from './rb-virtual-repeat.dir'

export default angular.module('rb.virtual-repeat', [])
  .config(CoreConfigure)
  .directive('rbVirtualRepeatContainer', rbVirtualRepeatContainer)
  .directive('rbVirtualRepeat', rbVirtualRepeat)
;

CoreConfigure.$inject = ['$provide'];
function CoreConfigure($provide) {
  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
}

rAFDecorator.$inject = ['$delegate'];
function rAFDecorator($delegate) {
  /**
   * Use this to throttle events that come in often.
   * The throttled function will always use the *last* invocation before the
   * coming frame.
   *
   * For example, window resize events that fire many times a second:
   * If we set to use an raf-throttled callback on window resize, then
   * our callback will only be fired once per frame, with the last resize
   * event that happened before that frame.
   *
   * @param {function} cb function to debounce
   * @returns {function} A throttled version of the given function
   */
  $delegate.throttle = function(cb) {
    let queuedArgs, alreadyQueued, queueCb, context;
    return function debounced(...args) {
      queuedArgs = [...args];
      // eslint-disable-next-line no-invalid-this
      context = this;
      queueCb = cb;
      if (!alreadyQueued) {
        alreadyQueued = true;
        $delegate(function() {
          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
          alreadyQueued = false;
        });
      }
    };
  };
  return $delegate;
}
